import { db } from "../../firebase";
import { doc, updateDoc } from "firebase/firestore";

const UpdateClient = async (bid, data) => {
  /**
   * input: uid: users id
   * output: user
   * description: fetches user
   */

  try {
    const userDoc = await doc(db, "clients", bid);
    const userDocSnapshot = await updateDoc(userDoc, data);
    // if (getAuth().currentUser.email!==data.email) {
    //     linkWithCredential(getAuth.currentUser, )
    // }
    // const userDocDetails = userDocSnapshot.data();
    return true;
  } catch (error) {
    console.log(error);
  }
};

export default UpdateClient;
